import { Helpers } from '../../helpers';
import { IFundingCategoryAssembly } from '../../interfaces/ifunding-category-assembly';
import { FundingCategoryAssemblyJunction } from '../funding-category-assembly-junction';
import { UnitOfMeasure } from '../unit-of-measure';

export class FundingCategoryAssemblyBase {
  FundingCategoryAssemblyId: number;
  Name: string;
  Percentage: number | null;
  UnitOfMeasureId: number | null;
  UnitInput: string | null;
  Rate: number | null;
  Quantity: number | null;
  StartDate: Date | null;
  EndDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  FundingCategoryAssemblyJunctions_FundingCategoryAssembly?: Array<FundingCategoryAssemblyJunction> | null;
  UnitOfMeasure?: UnitOfMeasure;

  constructor(item?: IFundingCategoryAssembly) {
    if (item) {

      this.FundingCategoryAssemblyId = item.FundingCategoryAssemblyId;
      this.Name = item.Name;
      this.Percentage = item.Percentage;
      this.UnitOfMeasureId = item.UnitOfMeasureId;
      this.UnitInput = item.UnitInput;
      this.Rate = item.Rate;
      this.Quantity = item.Quantity;
      this.StartDate = item.StartDate ? new Date(item.StartDate) : null;
      this.EndDate = item.EndDate ? new Date(item.EndDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.FundingCategoryAssemblyJunctions_FundingCategoryAssembly = Helpers.createClassArray(FundingCategoryAssemblyJunction, item.FundingCategoryAssemblyJunctions_FundingCategoryAssembly);
      this.UnitOfMeasure = new UnitOfMeasure(item.UnitOfMeasure);
    }
  }
}